import React from 'react';
import Immutable from 'immutable';
import { ReactComponent as NotificationIcon } from '../svg/notifications.svg';

import {
	FlexBox,
	FlexBoxBlock,
	styled
} from 'ps-gui';
import { getPhrase } from '../data/phrases';

const EMPTY_LIST = Immutable.List([]);

const Wrapper = styled.div`
	border-bottom: 1px solid ${props => props.theme.pageSeparatorColor};
	padding: 21px;
	margin-bottom: 20px;
`;

const MenuItem = styled.span`
	display: inline-block;
	text-align: center;
	font-size: 16px;
	border-bottom: 2px solid transparent;
	font-weight: 500;
	padding: 3px;
	text-transform: uppercase;
	&.left {
		margin-right: 48px;
		font-weight: 500;
	}
	&.right {
		margin-left: 48px;
		font-weight: 300;
	}
	cursor: pointer;

	.widthDummy {
		height: 0;
		visibility: hidden;
		overflow: hidden;
		user-select: none;
		pointer-events: none;
		font-weight: 900;

		@media speech {
			display: none;
		}
	  }

	&:hover {
		font-weight: 900;
	}
	&.selected {
		font-weight: 900;
		border-bottom-color: ${props => props.theme.activeColor};
	}


	svg {
		vertical-align: top;
		margin-left: 8px;
	}
`;

export default class PageMenu extends React.PureComponent {
	onModuleSelected(moduleId) {
		if (typeof this.props.onModuleSelected === 'function') {
			this.props.onModuleSelected(moduleId);
		}
	}

	renderMenuItems(menuItems, className) {
		menuItems = menuItems || EMPTY_LIST;
		const selectedModuleId = this.props.selectedModuleId;
		return menuItems.map(moduleId => {
			const text = getPhrase(moduleId);
			return (
				<MenuItem
					key={moduleId}
					className={className + (moduleId === selectedModuleId ? ' selected' : '')}
					onMouseDown={e => {
						this.onModuleSelected(moduleId);
					}}
					data-text={text}
				>
					<div className="widthDummy">{text}</div>
					{text}
					{
						moduleId === 'Notifications' &&
						<NotificationIcon
						/>

					}
				</MenuItem>
			);
		});
	}

	render() {
		return (
			<Wrapper>
				<FlexBox>
					<FlexBoxBlock>
						{this.renderMenuItems(this.props.leftMenuItems, 'left')}
					</FlexBoxBlock>
					<FlexBoxBlock flexGrow="1"></FlexBoxBlock>
					<FlexBoxBlock>
						{this.renderMenuItems(this.props.rightMenuItems, 'right')}
					</FlexBoxBlock>
				</FlexBox>
			</Wrapper>
		);
	}
}

